import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {selectAuthState, UserState} from '../store/user/auth.state';
import {first, map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AuthService} from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RecruitmentGuard implements CanActivate {

  constructor(private store: Store<UserState>,
              private router: Router,
              private authService: AuthService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(selectAuthState).pipe(
      first(),
      map(userData => {
        if (this.authService.isAccessTokenExpired() || !userData.user) {
          this.router.navigate(['/'], {
            queryParams: {
              page: 'login'
            }
          });
          return false;
        }

        return true;
      })
    );
  }

}
